import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=3596615f&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=js&"
export * from "./NewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=3596615f&lang=less&scoped=true&"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596615f",
  null
  
)

export default component.exports